import { render, staticRenderFns } from "./NodaOpenBank.vue?vue&type=template&id=36949c33&"
import script from "./NodaOpenBank.vue?vue&type=script&lang=js&"
export * from "./NodaOpenBank.vue?vue&type=script&lang=js&"
import style0 from "./NodaOpenBank.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports